import React from "react";

import { useTranslation } from "react-i18next";

import ToggleOptionGroup from "./ToggleOptionGroup";

import type { JSX } from "react";

import type { ChartMode, TimelineGranularity } from "./charts.types";
import type { ToggleOption } from "./ToggleOptionGroup";

const PERIODIC_LABEL_KEY = {
  day: "charts.perDay",
  week: "charts.perWeek",
  month: "charts.perMonth",
} as const satisfies Record<TimelineGranularity, string>;

interface ChartModeToggleProps {
  value: ChartMode;
  granularity: TimelineGranularity;
  onChange: (mode: ChartMode) => void;
}

function ChartModeToggle({
  value,
  granularity,
  onChange,
}: ChartModeToggleProps): JSX.Element {
  const { t } = useTranslation("editor-analytics");

  const optionList = [
    { value: "periodic", label: t(PERIODIC_LABEL_KEY[granularity]) },
    { value: "cumulative", label: t("charts.cumulative") },
  ] satisfies ToggleOption<ChartMode>[];

  return (
    <ToggleOptionGroup
      ariaLabel={t("charts.mode")}
      onChange={onChange}
      optionList={optionList}
      value={value}
    />
  );
}

export default ChartModeToggle;
